import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ThemeProps } from '../../../../../shared/prop-types/ReducerProps';
import config from '../../../../../config';
import ItemEditModalForm from './ItemEditModalForm';

const priorityOptions = [
  { value: 'high', label: 'high' },
  { value: 'medium', label: 'medium' },
  { value: 'low', label: 'low' },
];

const ItemEditModal = ({
  todoElements,
  currentEditItem, changeShowEditModal, editTodoElementAction, addTodoElementAction,
  showEditModal, theme,
}) => {
  const user = useSelector(store => store.authentication.user);
  const [priority, setPriority] = useState({ value: 'low', label: 'low' });
  const [dueDate, setDueDate] = useState(new Date());
  const [initLoad, setInitLoad] = useState(true);
  const [editNew, setEditNew] = useState(true);

  useEffect(() => {
    if (currentEditItem && currentEditItem.id) {
      setPriority({ value: currentEditItem.priority, label: currentEditItem.priority });
      if (initLoad || editNew) {
        setDueDate(new Date(currentEditItem.dueDate));
        setInitLoad(false);
      }
      setEditNew(false);
    } else if (!editNew) {
      setPriority({ value: 'low', label: 'low' });
      setDueDate(new Date());
      setEditNew(true);
    }
  }, [currentEditItem, todoElements]);

  const handleDateChange = (date) => {
    setDueDate(date);
  };

  const handlePriorityChange = (option) => {
    setPriority(option);
  };

  const handleSubmit = (formData) => {
    let tempDueData = new Date();
    if (dueDate) {
      tempDueData = dueDate;
    }
    const updatedTodoData = {
      ...currentEditItem,
      title: formData.title,
      description: formData.description,
      assignedToEmail: formData.assignedToEmail,
      priority: priority.value,
      dueDate: moment(tempDueData).format('MM/DD/yyyy'),
    };
    if (!currentEditItem) {
      updatedTodoData.id = -(Date.now()); // new elements will have id < 0
    }
    if (updatedTodoData.title !== '') {
      if (!(currentEditItem && currentEditItem.id)) {
        addTodoElementAction(updatedTodoData, { headers: { ...config.jsonHeader, authorization: `JWT ${user.jwtToken}` } });
      } else {
        editTodoElementAction(updatedTodoData, { headers: { ...config.jsonHeader, authorization: `JWT ${user.jwtToken}` } });
      }
      changeShowEditModal();
    }
  };

  const modalClasses = classNames({
    'todo__add-modal': true,
  }, theme.className, 'ltr-support');

  return (
    <Modal
      isOpen={showEditModal}
      toggle={changeShowEditModal}
      className={modalClasses}
    >
      <ItemEditModalForm
        initialValues={currentEditItem}
        onSubmit={handleSubmit}
        changeShowEditModal={changeShowEditModal}
        handleDateChange={handleDateChange}
        handlePriorityChange={handlePriorityChange}
        currentEditItem={currentEditItem}
        dueDate={dueDate}
        priority={priority}
        priorityOptions={priorityOptions}
      />
    </Modal>
  );
};

ItemEditModal.propTypes = {
  todoElements: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  currentEditItem: PropTypes.shape(),
  changeShowEditModal: PropTypes.func.isRequired,
  editTodoElementAction: PropTypes.func.isRequired,
  addTodoElementAction: PropTypes.func.isRequired,
  showEditModal: PropTypes.bool.isRequired,
  theme: ThemeProps.isRequired,
};

ItemEditModal.defaultProps = {
  currentEditItem: null,
};

export default ItemEditModal;
